import { jsx as _jsx } from "react/jsx-runtime";
const Button = ({ variant = 'primary', size, disabled = false, outline = false, block = false, onClick, children, className = '', type = 'button' }) => {
    const buttonVariant = outline ? `outline-${variant}` : variant;
    // Create a proper button element with Bootstrap classes
    const buttonClasses = [
        'btn',
        `btn-${buttonVariant}`,
        size ? `btn-${size}` : '',
        block ? 'w-100' : '',
        className
    ].filter(Boolean).join(' ');
    return (_jsx("button", { className: buttonClasses, disabled: disabled, onClick: onClick, type: type, style: {
            border: 'none',
            borderRadius: '0.375rem',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.65 : 1,
            transition: 'all 0.15s ease-in-out',
        }, children: children }));
};
export default Button;
